import React from 'react';
import { Divider } from 'antd';
import { Typography } from 'ui-kit';
import OnboardingItem, { OnboardingItemProps } from '../OnboardingItem/OnboardingItem';
import './OnboardingItems.scss';

export interface OnboardingItemsProps {
  items: OnboardingItemProps[];
  secondaryItems?: OnboardingItemProps[];
}

export default function OnboardingItems({ items, secondaryItems }: OnboardingItemsProps) {
  const renderItems = (items) => {
    return items.map((props, idx) => <OnboardingItem key={idx} {...props} />);
  };
  return (
    <div className="OnboardingItems-container">
      {renderItems(items)}
      {Boolean(secondaryItems?.length) && (
        <>
          <Divider>
            <Typography variant="caption" color="textGray">
              OR
            </Typography>
          </Divider>
          {renderItems(secondaryItems)}
        </>
      )}
    </div>
  );
}
